import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { SETTINGS_URLS } from 'constants/routes'
import { TEXT_STYLES } from 'TEXT_STYLES'
import { isFeatureEnabled } from 'helpers/features'
import { Features } from 'constants/feature_names'
import { getPricingPageUrl } from 'helpers/account'
import { sendCtaClickEvent } from 'helpers/segment'
import { getUpsellModalCopy } from 'helpers/review_automation'
import { displayUpgradeModal } from 'helpers/account/users'
import { BaseModalLayout } from '../Modals/BaseModalLayout'

const ModalWrapper = styled(BaseModalLayout)`
  .modal-container {
    max-width: 518px;
    min-width: 518px;
  }
`

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const StyledImage = styled.img`
  max-width: 348px;
  margin-top: 21px;
`

const TitleLabel = styled.label`
  ${TEXT_STYLES.Coaching1};
  margin: 12px 0px;
`
const ContentLabel = styled.label`
  ${TEXT_STYLES.Coaching2Normal};
  b {
    font-size: inherit;
    font-weight: 700;
  }
`

const UpsellModal = ({ metadata }) => {
  const { t } = useTranslation(['account', 'review_automation'])
  const {
    user: { checkout_locale, currency, selected_language },
    membershipInfo,
    flagData
  } = useSelector(state => state.globalData)
  const { from_checkout } = membershipInfo || {}

  const { modalTitle, title, content } = getUpsellModalCopy(metadata?.type, t)

  const callToAction = t(
    'review_automation:UpsellModal.callToAction',
    'View new plan'
  )

  const cancelButton = t(
    'account:FeatureLimitModal.buttons.keepPlan',
    'Keep my plan'
  )
  const ctaClickLocation = `Upsell Modal - ${metadata?.initiator}`

  const destinationURL = () => {
    if (
      displayUpgradeModal(
        isFeatureEnabled(Features.STRIPE_CUSTOMER_PORTAL, flagData),
        from_checkout
      )
    ) {
      return `${window.location.origin}/#${SETTINGS_URLS.subscriptions}`
    }
    return getPricingPageUrl(checkout_locale, currency, selected_language)
  }

  return (
    <ModalWrapper
      title={modalTitle}
      content={
        <ModalContent>
          <StyledImage src="https://dh2wkbcb9yv3l.cloudfront.net/images/upsell/feature-limits.svg" />
          <TitleLabel>{title}</TitleLabel>
          <ContentLabel>{content}</ContentLabel>
        </ModalContent>
      }
      cancelButton={{
        label: cancelButton,
        onClick: () =>
          sendCtaClickEvent({
            text: cancelButton,
            location: ctaClickLocation,
            destination: 'modal'
          })
      }}
      submitButton={{
        label: callToAction,
        onClick: () => {
          sendCtaClickEvent({
            text: callToAction,
            location: ctaClickLocation,
            destination: destinationURL()
          })
          window.open(destinationURL(), '_blank')
        }
      }}
    />
  )
}

UpsellModal.defaultProps = {
  metadata: undefined
}
UpsellModal.propTypes = {
  metadata: PropTypes.shape({
    type: PropTypes.string,
    initiator: PropTypes.string
  })
}

export { UpsellModal }
